import { render, staticRenderFns } from "./carteirinha.vue?vue&type=template&id=543205a1"
import script from "./carteirinha.vue?vue&type=script&lang=js"
export * from "./carteirinha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports